import {globalCssExports} from 'utils/commonUtils';

/*

Use watchMediaQuery to attach event handlers the window changing it's size (and entering or leaving a medai quiry's matching state)

You need to attach in componentDidMount, and remove in componentWillUnmount or there will be a memory leak (at best) and probably errors.

watchMediaQuery returns a function that will unattach the listener.

e.g.

class Bob extends Component {
  constructor(...a) {
    super(...a);
    this.unwatchTablet = () => {}; // initial noop
  }

  componentDidMount() {
    this.unwatchTablet = watchMediaQuery("tablet", match => {
      console.log(`tablet ${match? "matches", "doesn't match"}`)
    });
  }

  componentWillUnmount() {
    this.unwatchTablet();
  }
}

*/
const mediaVars = globalCssExports("media");

export function watchMediaQuery(query, watcher) {
  const handler = e => watcher(e.matches);

  const mediaQuery = mediaVars[query] || query;
  const matcher = window.matchMedia(mediaQuery);

  matcher.addListener(handler);
  handler(matcher);

  return () => matcher.removeListener(handler);
}




// WEBPACK FOOTER //
// ./utils/mediaQueryHelpers.js